import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { RestService } from '../providers/rest.service';
import { HttpClient } from '@angular/common/http';
import { UserRole } from '../../shared/enum/enum';

@Injectable({
  providedIn: 'root'
})
export class PermissionService extends RestService {

  private permissions: any[] = [];
  private loaded = false;
  private user: any;

  constructor(
    protected http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    super(http);
  }

  setPermissions(list: any[]) {
    this.permissions = list;
    this.loaded = true;

    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('userrolepermissions', JSON.stringify(list));
    }
  }

  loadPermissionsFromStorage() {
    if (isPlatformBrowser(this.platformId)) {
      const saved = localStorage.getItem('userrolepermissions');
      if (saved) {
        this.permissions = JSON.parse(saved);
        this.loaded = true;
      }
    }
  }

  // moduleId: Id Of the corresponding module, action:action id , allowedDefaultExternalUserIds : containing external user Id if the external user(principal,1031,seller,external broker) uses any of the page that donot want permission
  hasPermission(module: number, action: number, allowedDefaultExternalUserIds: number[] = []): boolean {

    if (isPlatformServer(this.platformId)) {
      return true;
    }

    this.user = localStorage.getItem('currentUser');
    this.user = this.user ? JSON.parse(this.user) : null;

    if (!module || !action || this.user == null || this.user == undefined) {
      return false;
    }

    if (this.user != null && this.user != undefined && (
      this.user.RoleIdList?.includes(UserRole.Principal) ||
      this.user.RoleIdList?.includes(UserRole.Principal1031) ||
      this.user.RoleIdList?.includes(UserRole.Seller) ||
      this.user.RoleIdList?.includes(UserRole.ExternalBroker))
    ) {
      if (allowedDefaultExternalUserIds.length > 0) {
        return allowedDefaultExternalUserIds.some(role =>
          this.user.RoleIdList.includes(role)
        );
      }
      else {
        return false;
      }

    }
    else {
      if (!this.permissions || this.permissions.length <= 0) {
        this.loadPermissionsFromStorage();
      }
      if (this.permissions != null && this.permissions.length > 0) {
        return this.permissions.some(
          p => p.ModuleId === module &&
            p.ActionId === action
        );
      }
      else {
        return false;
      }
    }
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  getAllowedPermissions(roleId: number) {
    return this.GET('user/userPermissionList/' + roleId);
  }
}
